import React, {Component} from 'react';
import Messages from 'i18n/defaultMessages';
import {FormattedMessage} from 'react-intl';
import Loader from 'components/Loader';
import { Redirect } from 'react-router-dom';

export default class CompanyRoute extends Component {
    renderNoCompany = () => {
        const {company, loading} = this.props;
        if (loading || company) {
            return null; 
        }
        return (
            <div><FormattedMessage {...Messages.companyNotFound} /></div>
        );
    }
    
    componentDidMount() {
        this.props.onMount();
    }

    componentDidUpdate(prevProps) {
        if (this.props.companyId && (this.props.companyId !== prevProps.companyId)) {
            this.props.onCompanyChange();
        }
    }
    render() {
        const {locale, company, job, children, referrer, path} = this.props;
        if (!locale) {
            return <Loader loading />
        }

        if(path && path.startsWith('/r/')) {
            if(referrer) {
                const url = `${path.replace(/\/r\//, '/')}?r=${referrer}`;
                return <Redirect to={url} />
            }
            if(!referrer && window.location.href.includes('?r=')) {
                return <Redirect to={path} />
            }
        }
        if(path && !path.startsWith('/r/') && referrer && !window.location.href.endsWith(referrer)) {
            const url = `${path}?r=${referrer}`;
            return <Redirect to={url} />
        }
        
        const noCompanyMarkup = this.renderNoCompany();
        if (noCompanyMarkup) {
            return noCompanyMarkup;
        }
        if (company && job && company.id !== job.companyId) {
            return 'invalid link';
        }
        return children;
    }
}
